jQuery(document).ready(function () {
    if( jQuery('body').hasClass('plan-upgrade') ) // only load on this page
    {
        const currencyUnit = jQuery("#currencyUnit").val();
        //const address = JSON.parse( jQuery("#shippingAddress").val() );
        const taxRate = jQuery("#taxRate").val();
        const taxCounty = jQuery("#taxCounty").val();

        const taxData = {
            taxRate: taxRate,
            taxCounty: taxCounty
        }

        var collectionAddons = {};
        
        /*
        // shop snack collections add to order/remove from order
        jQuery('.add-collection').on('click', function (e) {
            jQuery(e.currentTarget)
                .addClass('d-none').addClass("added")
                .next('.remove-collection').removeClass('d-none');
            
            let collectionObject = {
                candybarId: e.currentTarget.dataset.cbpostid,
                accountId: e.currentTarget.dataset.id,
                crateSize:  e.currentTarget.dataset.cratetype,
                price: e.currentTarget.dataset.price,
                name: e.currentTarget.dataset.title,
                productName: e.currentTarget.dataset.fulfillmentname,
                crateImage: e.currentTarget.dataset.img,
                quantity: 1,
            };

            collectionObject.subscription_data = Object.assign(taxData, address);
            
            collectionAddons[e.currentTarget.dataset.cbpostid] = collectionObject;

            updateCart();
        });
        */
        
        jQuery('.remove-collection').on('click', function (e) {
            jQuery(e.currentTarget)
                .addClass('d-none')
                .prev('.add-collection').removeClass('d-none').removeClass("added");
            
            jQuery(`#collection-${e.currentTarget.dataset.id}`).remove();

            delete collectionAddons[e.currentTarget.dataset.cbpostid];
            
            updateCart();
        });

        jQuery('#modalAddOn').on('show.bs.modal', function(e) {
            updateCart();
        });

        jQuery('input[name="subscription-addon"]').on('change', function (e) {
            jQuery('#crateAddOns').find('[type="submit"]').first().attr('disabled', false);
            jQuery('#openModalAddOn').attr('disabled', false);
            updateCart();
        });

        jQuery("#crateAddOns").on('submit', function(e) {
            e.preventDefault();
            /*
            let upgradeType = null;
            if(jQuery("#addMonthly").is( ":checked" ))
            {
                upgradeType = 'monthly';
            }
            else if(jQuery("#getOnce").is( ":checked" ))
            {
                upgradeType = 'one_time';
            }
            */

            let postData= {};
            for(const field of jQuery(this).serializeArray())
            {
                postData[field.name] = field.value;
            }

            if( document.getElementById("drinkUpgrade") && document.getElementById("drinkUpgrade").checked )
            {
                postData.drinkUpgrade = 1;
                postData.free_drink = 1;

                document.getElementById("drinkUpgrade_payment").checked = true;
            }

            //postData.upgrade_type = upgradeType;
            //postData.collections = collectionAddons;

            jQuery(this).find('[type="submit"]').first().attr('disabled', 'disabled');
            jQuery('.loading_wrapper').fadeIn();

            submitAjaxForm( e.currentTarget.attributes.action.nodeValue, postData, jQuery("#alertContainer") );
        });

        function updateCart()
        {
            jQuery("#modalCart").empty();

            let cartCount = parseInt(0);
            let subTotal = 0.00;

            let typeVal = jQuery("input[name='upgrade_type']").val();
            let type = typeVal.slice(0,1).toUpperCase() + typeVal.slice(1);
            //if( jQuery("#addMonthly").is( ":checked" ) )
            if( typeVal == 'size' )
            {
                addCardToCart( `Monthly ${type} Upgrade`, jQuery("#addMonthly").data('price'), jQuery("#addMonthly").data('img'), "monthlySubUpdate", true );
                subTotal += parseFloat( jQuery("#addMonthly").data('price') );
                cartCount = 1;
            }
            //else if( jQuery("#getOnce").is( ":checked" ) )
            //{
                //addCardToCart( `One-Time ${type} Upgrade`, jQuery("#getOnce").data('price'), jQuery("#getOnce").data('img'), "oneTimeAddon" );
                //subTotal += parseFloat( jQuery("#getOnce").data('price') );
                //cartCount = 1;
            //}

            if( document.getElementById("drinkUpgrade") && document.getElementById("drinkUpgrade").checked )
            {
                addCardToCart( `Monthly Drink Upgrade`, jQuery("#drinkUpgrade").data('price'), jQuery("#drinkUpgrade").data('img'), "monthlySubUpdate", true );
                subTotal += parseFloat( jQuery("#drinkUpgrade").data('price') );
            }

            for (const [key, collection] of Object.entries(collectionAddons)) {
                addCardToCart( collection.name, collection.price, collection.crateImage, "collection-" + collection.candybarId, false, true, collection.quantity )
                subTotal += collection.price * collection.quantity;
                cartCount += parseInt(collection.quantity);
            }

            jQuery("#cartCount").text( cartCount );

            let taxTotal = taxRate == 0 ? "--" : currencyUnit + ( String( (subTotal * taxRate).toFixed(2) ) );
            let grandTotal = subTotal + (subTotal * taxRate);

            jQuery("#subTotal").text( currencyUnit + String(subTotal.toFixed(2)) );
            jQuery("#grandTotal").text( currencyUnit + String(grandTotal.toFixed(2)) );
            jQuery("#taxTotal").text( taxTotal );
        }

        function addCardToCart( title, price, image, id, isRecurring = false, isCollection = false, quantity = 1 )
        {
            let priceDisplay = price == 0 ? "First Month Free" : `$${price}`;
            let html = `<div class="rebrand-card rebrand-frame card-list w-100 mx-auto mb-3" id="${id}">
                <div class="card-body">
                    <div class="d-flex align-items-center justify-content-between">
                        <div class="pr-2">
                            <img src="${image}"
                                class="img-fluid"/></div>
                        <div class="px-2 mr-auto">
                            <p class="h8 h7-md mb-1">${title}</p>
                            <p class="h8 h7-md mb-0">${priceDisplay}</p>`;

            if( isRecurring )
            {
                html += `
                    <div class="d-flex align-items-center mt-1"    
                        <span>
                            <img src="/wp-content/themes/wp-bootstrap-starter-child/assets/svg/icon-recurring.svg"
                                class="img-fluid pl-1"
                                alt="Blue arrow icon indicating recurring subscription">
                         </span>
                      `;

                if( price == 0 )
                {
                    let drinkPrice = jQuery("#drinkPriceDisplay").val();
                    html += `<span class="ml-2 small">${drinkPrice} Recurs monthly</span>`;
                }
                html += `</div>`;
            }
            else if( isCollection )
            {
                let candybarId = id.replace("collection-", "");
                html += `</div><div class="px-2 ml-auto">
                    <div class="form-group form-select-quantity position-relative mb-0">
                        <label class="h9 h8-md px-1 bg-white position-absolute text-gray-medium">Quantity</label>
                        <select class="form-control custom-select collection-qty text-gray-medium pl-md-3" data-cbid="${candybarId}">`;
                            for( let i = 1; i <= 5; i++) {
                                if( quantity == i )
                                {
                                    html += `<option selected>${i}</option>`;
                                }
                                else
                                {
                                    html += `<option>${i}</option>`;
                                }
                            }
                html += `</select>
                    </div>
                </div>`;
            }
            
            html += `       </p>
                        </div>
                        <!--<div class="pl-5"><a class="btn-remove h9 h7-md">Remove</a></div>-->
                    </div>
                </div>
            </div>`;

            jQuery("#modalCart").append(html);

            initializeCartActions();
        }

        function initializeCartActions()
        {
            jQuery('.btn-remove').unbind('click');
            // Remove crate from the list
            jQuery('.btn-remove').on('click', function (e) {
                let card = jQuery(this).closest('.rebrand-card');
                
                if( jQuery(card).attr('id').includes('collection') )
                {
                    let collectionId = jQuery(card).attr('id').replace( 'collection-', '' );
                    jQuery(`.remove-collection[data-cbpostid="${collectionId}"`).click();
                }
                else
                {
                    jQuery('#crateAddOns').find('[type="submit"]').first().attr('disabled', 'disabled');
                    jQuery('#openModalAddOn').attr('disabled', 'disabled');
                    jQuery("#addMonthly, #getOnce").prop('checked', false);
                    updateCart();
                }

                jQuery('#modalAddOn').modal('hide');
            });
            
            jQuery(".collection-qty").unbind('change');
            jQuery(".collection-qty").on('change', function(e) {
                const collectionKey = e.currentTarget.dataset.cbid;

                collectionAddons[collectionKey].quantity = e.currentTarget.value;

                updateCart();
            });
        }
    }
});

function addonPaymentFailed( price )
{
    var stripe;
    if (window.location.href.indexOf('local') !== -1 || window.location.href.indexOf('staging') !== -1 || window.location.href.indexOf('account-dev') !== -1) {
        stripe = window.Stripe('pk_test_n3rrzyh2ClIZlnCntL9X8IRx');
    }
    else
    {
        stripe = window.Stripe('pk_live_3L8cvOKHqpOpDF3JXfZqZTd2');
    }
    var elements = stripe.elements();

    let appearance = {
        style: {
            base: {
                color: '#2d3047',
                fontWeight: 500,
                fontSize: '16px',
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                border: '1.5px solid #ff0',
                padding: '8px 16px',
                '::placeholder': {
                    color: '#ababab',
                    fontWeight: 500,
                },
            },
        }
    };
    
    //var cardName = elements.create('cardName');
    var cardNumber = elements.create('cardNumber', appearance);
    var cardExpiry = elements.create('cardExpiry', appearance);
    var cardCvc = elements.create('cardCvc', appearance);
    var cardZip = elements.create('postalCode', appearance);

    cardNumber.update({placeholder: 'Card Number'});
    cardZip.update({placeholder: 'ZIP CODE'});
    
    // Add an instance of the card Element into the `card-element` <div>
    cardNumber.mount('#card-number');
    cardExpiry.mount('#card-expiry');
    cardCvc.mount('#card-cvc');
    cardZip.mount('#card-zip');

    cardNumber.addEventListener('change', handleCardError);
    cardExpiry.addEventListener('change', handleCardError);
    cardCvc.addEventListener('change', handleCardError);
    cardZip.addEventListener('change', handleCardError);


    jQuery("#addOnsFailedPayment").on(
        'submit', 
        function(e) 
        {
            e.preventDefault();            
            stripe.createToken(cardNumber).then(
                function(result) 
                {
                    if (result.error) 
                    {
                        handleCardError(result);
                    } 
                    else 
                    {   

                        successfulPaymentUpdate(result);
                        
                    }
                }
            );
        }
    );

    /**
     * express pay
     */ 
    let paymentRequestAP = stripe.paymentRequest(
        {
            country: "US",
            currency: "usd",
            total: {
                label: "SnackCrate",
                amount: Math.round(price * 100),
            },
            requestPayerName: true,
            requestPayerEmail: false,
            requestShipping: false,
        }
    );

    let prButton = elements.create('paymentRequestButton', 
        {
            paymentRequest: paymentRequestAP,
            style: {
                paymentRequestButton: {
                    type: 'default', // default: 'default'
                    theme: 'dark', // default: 'dark'
                    height: '56px', // default: '40px', the width is always '100%'
                },
            },
        }
    );

    paymentRequestAP.canMakePayment().then(
        function(result) 
        {
            if (result) 
            {
                prButton.mount('#thirdPartyPaymentButtons');
                jQuery('#thirdPartyPayment').removeClass('d-none');
                jQuery('#thirdPartyPayment').show();
            } 
            else 
            {
                jQuery('#thirdPartyPayment').addClass('d-none');
                jQuery('#thirdPartyPayment').hide();
            }
        }
    );

    paymentRequestAP.on('token', 
        function(event) 
        {
            event.complete('success');
            successfulPaymentUpdate( event );
        }
    );
}

function handleCardError( event )
{
    var displayError = document.getElementById('card-errors');
    if (event.error) 
    {
        displayError.textContent = event.error.message;
        //jQuery('[data-sc-button="submitNewSubscription"]').attr('disabled',true);
    } 
    else 
    {
        displayError.textContent = '';

        //if(dataComplete && event.complete)
        //    jQuery('[data-sc-button="submitNewSubscription"]').removeAttr('disabled');
    }
}

function successfulPaymentUpdate( paymentData )
{    
    // Insert the token ID into the form so it gets submitted to the server
    let postData = {};
    postData.token = paymentData.token.id;
    postData.cardName = 'payerName' in paymentData ? paymentData.payerName : document.getElementById("card-name").value;

    for(const field of jQuery("#addOnsFailedPayment").serializeArray())
    {
        postData[field.name] = field.value;
    }

    if( document.getElementById("drinkUpgrade_payment") && document.getElementById("drinkUpgrade_payment").checked )
    {
        postData.drinkUpgrade = 1;
        postData.free_drink = 1;
    }
    jQuery(this).find('[type="submit"]').first().attr('disabled', 'disabled');
    jQuery('.loading_wrapper').fadeIn();

    submitAjaxForm( document.getElementById('addOnsFailedPayment').attributes.action.nodeValue, postData, jQuery("#card-errors") );
}